





















































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { Address, LobAddressValidationResult } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    Button
  }
})
export default class LobAddressSuggestionModal extends Vue {

  @Prop()
  showPopup: boolean;

  @Prop()
  onSubmit: (useSuggestion: number) => void;

  @Prop()
  originalAddress: Address;

  @Prop()
  suggestedAddress: Address;

  @Prop()
  result: LobAddressValidationResult;

  @Prop()
  validationFootnotes: string [];

  isOpen = false;

  @Watch("showPopup")
  setIsOpen () {
    this.isOpen = this.showPopup;
  }

  onHidden (e) {
    this.handleSubmit(0);
  }

  handleSubmit (value: number) {
    this.isOpen = false;
    this.onSubmit(value);
  }

  get isDeliverable () {
    return this.result === LobAddressValidationResult.Confirmed ||
      this.result === LobAddressValidationResult.ConfirmedWithSuggestion;
  }

  get noSuggestionMessage () {
    return "Unable to verify address. Please review the address entered to ensure accurate delivery.";
  }

  get validationMessage () {
    return this.validationFootnotes !== undefined && this.validationFootnotes !== null ? this.validationFootnotes[0] : "";
  }
}
